import { Component } from '@angular/core'
import { IonicPage, NavController, NavParams, ToastController } from 'ionic-angular'
import { Condominium, HousingUnit } from '../../models/models'
import { CondominiumProvider } from '../../providers/condominium/condominium'

import { ControlPanelPage } from '../control-panel/control-panel'
@IonicPage()
@Component({
	selector: 'page-housing-unit-index',
	templateUrl: 'housing-unit-index.html',
})
export class HousingUnitIndexPage {
	public condominium: Condominium = null;
	public housingUnits: HousingUnit[] = null;
	public isLoading: boolean = true;

	constructor(
		public condominiums: CondominiumProvider,
		public navCtrl: NavController,
		public navParams: NavParams,
		public toastCtrl: ToastController
	) {
		this.condominium = navParams.get('condominium')//esegue il caricamento delle unità immobiliari al refresh
	}
	public goToControlPanel() {
		this.navCtrl.setRoot(ControlPanelPage)
	}

	ionViewDidLoad() {
		this.refresh()
	}


	/*
	Rilettura del condominio
	*/
	private refresh() {
		let self = this


		if(this.condominium) {//caso unità di un condominio
			this.isLoading = true
			this.condominiums.getById(this.condominium.id, [
				'housingUnits',
				'housingUnits.userRoles',
				'userRoles'
			]).then(
				(condominium: Condominium) => {
					self.housingUnits = self.condominium.housing_units = self.condominium.housing_units.sort((hu1: HousingUnit, hu2: HousingUnit) => {
						let s1 = (hu1.stair + '-'
							+ hu1.floor + '-'
							+ hu1.internal + '-'
							+ hu1.label).toUpperCase()

						let s2 = (hu2.stair + '-'
							+ hu2.floor + '-'
							+ hu2.internal + '-'
							+ hu2.label).toUpperCase()

						if(s1 === s2) return 0
						if(s1 > s2) return 1
						return -1
					})

					self.isLoading = false
					console.debug('Condominio recuperato insieme alle unità immobiliari: ', self.condominium)
				},
				(error) => {
					self.isLoading = false
					console.error("Errore recuperando le unità immobiliari del condominio:", error)
					let toast = self.toastCtrl.create({
						message: 'Errore recuperando le unità immobiliari del condominio',
						position: 'middle',
						duration: 3000,
						cssClass: "danger"
					})
					toast.present()
				}
			)
		}
	}
}



// WEBPACK FOOTER //
// ./src/pages/housing-unit-index/housing-unit-index.ts